<template>
    <div class="component component__coursefeedbackform">
        <div class="columns is-variable">
            <div class="column">
                <component-title
                    :class="'component__coursefeedbackform_title'"
                    :size="'small'"
                    :underline="false"
                    :raw="true"
                >Feedback form</component-title>
                <component-text
                    :class="'component__coursefeedbackform_description'"
                >Fill in the feedback form to complete the course.</component-text>
            </div>
            <div class="column is-narrow">
                <component-button
                    :name="'component-coursefeedbackform-launch'"
                    :animate-loading="true"
                    :animate-loading-event-name="'feedback-open'"
                    :animate-loading-force="requestPending"
                    :disabled="disabled"
                    @click="openFeedbackForm"
                >Open form</component-button>
            </div>
        </div>
        <pop-notify
            ref="feedbackform"
            :class="'pop__notify--booking'"
            :title-text="'Feedback form'"
            :content-text="'Please fill the feedback form to complete the course.'"
            :form-active="true"
            :form-fields="feedbackFormFields"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Submit'"
            :submit-button-animate-loading-name="'feedback-submit'"
            :prevent-close="true"
            @emit-form="updateFields"
            @emit-submit="performSubmit"
        />
    </div>
</template>

<script>
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentButton from '@/components/default/shared/ComponentButton'
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentText from '@/components/default/shared/ComponentText'
export default {
  name: 'component-course-feedback-form',
  components: { ComponentText, PopNotify, ComponentButton, ComponentTitle },
  data () {
    return {
      requestPending: false
    }
  },
  props: {
    feedbackFormId: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    feedbackFormFields () {
      return this.$store.getters.getEbsCourseFeedbackFields
    }
  },
  methods: {
    updateFields (data) {
      this.$store.dispatch('ebsCourseFeedbackUpdateFields', data)
    },
    performSubmit () {
      this.$store.dispatch('ebsCourseFeedbackSubmit').then(() => {
        this.$eventBus.$emit('perform-get-course')
        this.$refs.feedbackform.closeNotify()
      }).finally(() => {
        this.$emit('emit-submit')
        this.$eventBus.$emit('stop-feedback-submit')
      })
    },
    openFeedbackForm () {
      this.requestPending = true
      this.$store.dispatch('ebsCourseFeedbackClear')
      this.$store.dispatch('lmsSuperadminWorkspaceFeedbackFormGet', { feedbackFormId: this.feedbackFormId }).then(response => {
        const isFeedbackFormDefault = response.default
        let feedbackFormFields = response.fields

        if (isFeedbackFormDefault) {
          for (let field of feedbackFormFields) {
            field.validation.mandatory = true
          }
        }

        this.$store.dispatch('ebsCourseFeedbackPreloadForm', feedbackFormFields)
        this.$refs.feedbackform.openNotify()
      }).finally(() => {
        this.requestPending = false
        this.$eventBus.$emit('stop-feedback-open')
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentcoursefeedbackform";
</style>
